// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import ReceiptIcon from '@material-ui/icons/Receipt';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';

// core components/views for Admin layout
import DashboardPage from "views/Dashboard/Dashboard.js";
import SellSellsman from "views/SellSellsman/SellSellsman.js";
import OrderSellsman from "views/OrderSellsman/OrderSellsman.js";
import ClientsSellsman from "views/ClientsSellsman/ClientsSellsman";
import ComissionSellsman from "views/ComissionSellsman/ComissionSellsman";

const dashboardRoutes = [
  /*{
    path: "/dashboard",
    name: "Início",
    icon: Dashboard,
    component: DashboardPage,
    layout: "/sellsman"
  },*/
  {
    path: "/sell",
    name: "Vendas",
    icon: "payments",
    component: SellSellsman,
    layout: "/sellsman"
  },
  {
    path: "/order",
    name: "Pedidos",
    icon: ReceiptIcon,
    component: OrderSellsman,
    layout: "/sellsman"
  },
  {
    path: "/clients",
    name: "Cliente",
    icon: AssignmentInd,
    component: ClientsSellsman,
    layout: "/sellsman"
  },
  {
    path: "/comission",
    name: "Comissão",
    icon: AccountBalanceIcon,
    component: ComissionSellsman,
    layout: "/sellsman"
  }
];

export default dashboardRoutes;
